import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import Lk from '../components/PrimaryAccount/Lk';
import { BACKEND_URL } from '../consts';

const getSubsDataUrls = async () => {
    const responseUrls = await fetch(`${BACKEND_URL}/api/v1/profile/subscribes/urls`);
    const responseData = await fetch(`${BACKEND_URL}/api/v1/profile/subscribes`);
    return [await responseData.json(), await responseUrls.json()];
}

const LkApp = () => {

    const [subsData, setSubsData] = useState({});
    const [subsUrls, setSubsUrls] = useState({});
    const [orderList, setOrderList] = useState([]);
    const [profile, setProfile] = useState({});
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = async () => {
        try {
            const responseProfile = await fetch(`${BACKEND_URL}/api/v1/profile`);
            if (!responseProfile.ok) {
                let err = new Error('Network response was not ok');
                err.response = responseProfile;
                throw err;
            }
            const responseOrders = await fetch(`${BACKEND_URL}/api/v1/profile/orders`);
            if (!responseOrders.ok) {
                let err = new Error('Network response was not ok');
                err.response = responseOrders;
                throw err;
            }
            const responseLk = await fetch(`${BACKEND_URL}/api/v1/block/api/v1/ula/LK`);
            if (!responseLk.ok) {
                let err = new Error('Network response was not ok');
                err.response = responseLk;
                throw err;
            }
            const lk = await responseLk.json();
            const orders = await responseOrders.json();
            const profile = await responseProfile.json();
            const [sData, sUrls] = await getSubsDataUrls();
            setSubsData(sData);
            setSubsUrls(sUrls);
            setProfile(profile);
            setOrderList(orders);
            setData(lk);
        } catch (error) {
            if (error.response && error.response.status == 401) {
                // alert("Пользователь не вошел в аккаунт. Вы будете перенаправлены на страницу входа");
                Cookies.remove("token");
                window.location.replace("/login");
                return;
            }
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {

        fetchData();
    }, []);

    return (
        <>
            <div className="App font-medium w-[100%] h-[100vh]">
                {
                    data.map((block) => {
                        switch (block.type) {
                            case "lk":
                                return (
                                    <Lk subsData={subsData} subsUrls={subsUrls} data={block.payload} profile={profile} orderList={orderList} />
                                )
                        }
                    })
                }
            </div>
        </>
    );
};

export default LkApp;
